export default {
  types: {
    A: {
      title: 'Bifhjól',
      passengers: '1-2 farþegar',
      name: 'Bifhjól / 1-2 farþegar / {price}',
    },
    B: {
      title: 'Einkabifreið',
      passengers: '1-5 farþegar',
      name: 'Einkabifreið / 1-5 farþegar / {price}',
    },
    C: {
      title: 'Stærri einkabifreið',
      passengers: '6-9 farþegar',
      name: 'Stærri einkabifreið / 6-9 farþegar / {price}',
    },
    D: {
      title: 'Minni rúta',
      passengers: '10-19 farþegar',
      name: 'Minni rúta / 10-19 farþegar / {price}',
    },
    E: {
      title: 'Rúta',
      passengers: '20-32 farþegar',
      name: 'Rúta / 20-32 farþegar / {price}',
    },
    F: {
      title: 'Stærri rúta',
      passengers: '33 farþegar og yfir',
      name: 'Stærri rúta / 33 farþegar og yfir / {price}',
    },
  },
  instructions: {
    title: 'Þegar ekið er inn og út af bílastæðinu er bílnúmer ökutækis lesið og það borið saman við greiðslur á þjónustugjaldi.',
    step1: 'Veldu stærð ökutækis',
    step2: 'Sláðu inn bílnúmer ökutækis',
    step3: 'Sláðu inn netfang til að fá kvittun',
    note: 'Engin þörf er á að þú setir prentaðan miða í glugga ökutækis',
    example: 'Dæmi af númeraplötu á ökutæki: ',
    plate: 'ABC12',
  },
  complete: {
    thankYou: 'Takk fyrir',
    success: 'Greiðsla tókst fyrir ökutæki',
    total: 'Upphæð',
    receipt: 'Kvittun var send á netfangið:',
    reset: 'Borga fyrir annað stæði',
  },
  dialogs: {
    plate: {
      title: 'Sláðu inn bílnúmer',
      licencePlate: 'Númeraplata',
      email: 'Netfang til að senda kvittun á',
      continue: 'Áfram',
      cancel: 'Hætta við',
    },
  },
  payment: {
    form: {
      name: 'Nafn korthafa *',
      card: 'Kortanúmer *',
      expire: 'Gildistími *',
      ccv: 'CVC *',
      terms: 'Lesa skilmála Checkit',
      toc: 'Ég samþykki skilmála Checkit *',
      email: 'Netfang',
      back: 'Til baka',
      confirm: 'Klára og borga',
      payment: 'Greiðslu upplýsingar',
    },
    information: {
      payment: 'Gjald fyrir',
      total: 'Upphæð',
    },
    secure3d: {
      hint: 'Smelltu á “Senda” til að hefja sterka auðkenningu (SCA) á greiðslukortinu.',
      about: 'Hvað er sterk auðkenning (SCA)?',
      submit: 'Senda',
      cancel: 'Hætta við',
    },
  },
  errors: {
    licencePlate: {
      noInput: 'Númeraplata verður að vera að minnsta kosti 2 stafir',
      invalidEmail: 'Gildi er ekki gilt netfang',
    },
    payment: {
      name: 'Nafn korthafa má ekki vera tómt',
      cardNumber: {
        isEmpty: 'Kortanúmer má ekki vera tómt',
        isToShort: 'Kortanúmer er ekki nógu langt',
        isInvalid: 'Innslegið gildi er ekki gilt kortanúmer',
      },
      month: 'Má ekki vera tómt',
      monthInvalid: 'Mánuður ekki til',
      expired: 'Kort útrunnið',
      year: 'Má ekki vera tómt',
      ccv: 'Má ekki vera tómt',
    },
    dialog: {
      default: {
        title: 'Villa',
        message: 'Keyrsla skilaði villu: "{error}"',
      },
      networkError: {
        title: 'Sambandsrof',
        message: 'Ekki náðist samband við þjónustur. Athugaðu hvort tækið sé tengt við internetið.',
      },
      paymentGatewayFailure: {
        title: 'Villa frá greiðslugátt',
        message: 'Ekki tókst að greiða með kortinu. Athugaðu hvort kortaupplýsingar séu réttar og næg innistæða sé á kortinu.',
      },
      code: {
        500: {
          title: 'Villa frá vefþjónustu',
          message: 'Vefþjónusta gat ekki framkvæmt aðgerð: "{error}"',
        },
      },
    },
  },
};
